<template>
<center>
    <div class="card card-body agatrs-card-style">
        <Header pageTitle="Email Confirmation" class="card-container"></Header>

        <p>{{confirmEmailMessage}}</p>
        <div class="row">
            <div class="col-md-2 offset-md-5">
            <!-- <base-button v-if="accountConfirmedStatus != 'NONE'" @click="onContinueToLoginClicked" type="primary"><i class="tim-icons icon-double-right"></i>Proceed to login</base-button> -->
            <base-button v-if="accountConfirmedStatus == 'ACCOUNT_CONFIRM_ERROR'" @click="onResendConfirmationEmailClicked" type="primary">Re-send confirmation email?</base-button>
            </div>
        </div>
    </div>
</center>
</template>

<script>
import Utility from "@/mixins/utility/utility";
import axios from "@/axios";
import Header from "@/components/App/Header";

export default {
    name: "ConfirmEmail",
    components: {
        Header,
    },
    mixins: [Utility],
    data() {
        return {
            confirmEmailMessage: "",
            accountConfirmedStatus: "NONE",
        };
    },
    mounted() {
        this.confirmEmailFromServer();
    },
    methods: {
        confirmEmailFromServer() {
            let id = null;
            let code = null;

            const pageParams = this.getPageUrlParameters();
            if (!this.isNullOrEmpty(pageParams)) {
                id = pageParams.id;
                code = pageParams.code;
            }

            if (!this.isNullOrEmpty(id) && !this.isNullOrEmpty(code)) {
                this.confirmEmailMessage = "Confirming account...";

                const params = {
                    Id: id,
                    Code: code,
                };

                const self = this;

                axios
                    .post("api/authentication/confirmemail", params)
                    .then((response) => {
                        const isUnsuccessful = response.data.includes(
                            "Error confirming your email"
                        );

                        if (isUnsuccessful) {
                            self.confirmEmailMessage =
                                "There was an error confirming your account.";
                            self.accountConfirmedStatus = "ACCOUNT_CONFIRM_ERROR";
                        } else {
                            self.confirmEmailMessage = response.data;
                            self.accountConfirmedStatus = "ACCOUNT_CONFIRMED";
                        }
                    })
                    .catch((error) => {

                        let errorMessage = "";
                        if (
                            !self.isNull(error) &&
                            !self.isNull(error.response) &&
                            !self.isNullOrEmpty(error.response.data)
                        ) {
                            errorMessage = error.response.data;
                        }

                        if (self.isNullOrEmpty(errorMessage)) {
                            errorMessage = "There was an error confirming your account.";
                        }

                        self.confirmEmailMessage = errorMessage;
                        self.accountConfirmedStatus = "ACCOUNT_CONFIRM_ERROR";
                    });
            } else {
                this.confirmEmailMessage =
                    "There was an error confirming your account.";
            }
        },
        onContinueToLoginClicked() {
            this.$router.push({
                name: "Login"
            });
        },
        onResendConfirmationEmailClicked() {
            const self = this;

            let id = null;

            const pageParams = this.getPageUrlParameters();
            if (!this.isNullOrEmpty(pageParams)) {
                id = pageParams.id;
            }

            const params = {
                id: id,
            };

            axios.get("api/authentication/resendconfirmemail", {
                    params
                })
                .then((response) => {
                    self.confirmEmailMessage = "The confirmation email has been sent.";
                    self.$notify({
                        verticalAlign: 'top',
                        horizontalAlign: 'center',
                        type: 'primary',
                        message: "The confirmation email has been sent."
                    });
                })
                .catch((error) => {

                    self.confirmEmailMessage =
                        "There was an error sending the confirmation email.";
                    self.accountConfirmedStatus = "ACCOUNT_CONFIRM_ERROR";
                });
        },
    },
};
</script>

<style scoped>
</style>
